import React from 'react';

const PullToRefreshIndicator = ({ pullDistance, isRefreshing, isPulling }) => {
    const threshold = 80;
    const progress = Math.min(pullDistance / threshold, 1);
    const opacity = isRefreshing ? 1 : Math.min(pullDistance / 30, 1);

    if (!isPulling && !isRefreshing) return null;

    return (
        <div 
            className="pull-to-refresh-indicator"
            style={{
                top: isRefreshing ? 60 : Math.max(pullDistance - 50, 10),
                opacity: opacity,
                transition: isPulling ? 'none' : 'all 0.3s ease-out'
            }}
        >
            <div 
                style={{
                    width: '50px',
                    height: '50px',
                    backgroundColor: 'rgba(17, 17, 17, 0.95)',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(76, 175, 80, 0.2)',
                    backdropFilter: 'blur(10px)',
                    border: '2px solid rgba(76, 175, 80, 0.3)',
                    position: 'relative',
                    zIndex: 1000
                }}
            >
                {isRefreshing ? (
                    // Spinner animation
                    <div
                        className="pull-refresh-spinner"
                        style={{
                            width: '28px',
                            height: '28px',
                            border: '3px solid rgba(76, 175, 80, 0.2)',
                            borderTop: '3px solid #4CAF50',
                            borderRadius: '50%'
                        }}
                    />
                ) : (
                    // Elegant pull indicator arrow
                    <svg 
                        width="24" 
                        height="24" 
                        viewBox="0 0 24 24" 
                        fill="none"
                        style={{
                            transform: `rotate(${progress * 180}deg)`,
                            transition: 'transform 0.1s ease-out'
                        }}
                    >
                        <path 
                            d="M12 5V19M5 12L12 19L19 12" 
                            stroke="#4CAF50" 
                            strokeWidth="2.5" 
                            strokeLinecap="round" 
                            strokeLinejoin="round"
                            style={{
                                opacity: 0.6 + (progress * 0.4)
                            }}
                        />
                    </svg>
                )}
            </div>
        </div>
    );
};

export default PullToRefreshIndicator;
